<template>
  <div :class="checkWidth() + ' ' + 'container example-3d'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <template v-if="CheckWidth >= 501">
        <CRow alignHorizontal="end" style="margin-right: 50px">
          <CCol
            col="2"
            style="text-align: center"
            @mouseover="hover = true"
            @mouseleave="hover = false"
          >
            <template>
              <h4>Post-Test</h4>
              <img
                v-if="!openPostTest"
                :class="postTestClass()"
                src="https://mdl.mfu.ac.th/chinese/Image/ITEM/paperroll/close_box.png?fbclid=IwAR3Dm6cvqoZgKkOgWAQgTW_vWDCFJiZMdsYkxJdaoiIIc-zPwPqPj4DiGdQ"
                style="width: 150px; height: 150px"
              />
              <img
                v-else-if="openPostTest && postTest"
                :class="postTestClass()"
                src="https://mdl.mfu.ac.th/chinese/Image/ITEM/paperroll/open_box.png?fbclid=IwAR3RqdS3kXALPpUCckSw1ixhI292Ni8fGkOEODUcB1QCpc28bExvTyJXVJI"
                style="width: 150px; height: 150px"
              />
              <img
                v-else-if="openPostTest && !postTest && hover"
                :class="postTestClass()"
                src="https://mdl.mfu.ac.th/chinese/Image/ITEM/paperroll/open_box.png?fbclid=IwAR3RqdS3kXALPpUCckSw1ixhI292Ni8fGkOEODUcB1QCpc28bExvTyJXVJI"
                style="width: 150px; height: 150px; cursor: pointer"
                @click="funcPostTest()"
              />
              <img
                v-else-if="openPostTest && !postTest && !hover"
                :class="postTestClass()"
                src="https://mdl.mfu.ac.th/chinese/Image/ITEM/paperroll/close_box.png?fbclid=IwAR3Dm6cvqoZgKkOgWAQgTW_vWDCFJiZMdsYkxJdaoiIIc-zPwPqPj4DiGdQ"
                style="width: 150px; height: 150px; cursor: pointer"
                @click="funcPostTest()"
              />
            </template>
          </CCol>
        </CRow>
      </template>

      <template v-else-if="CheckWidth <= 500">
        <CRow alignHorizontal="center" style="margin-bottom: 70px">
          <CCol col="6" style="text-align: center">
            <button
              v-if="openPostTest && !postTest"
              type="button"
              class="btn btn-success btn-lg"
              @click="funcPostTest()"
            >
              <font-awesome-icon
                icon="check-circle"
                style="margin-right: 5px"
              />
              POST TEST
            </button>
            <button v-else type="button" class="btn btn-danger btn-lg" disabled>
              POST TEST LOCKED
            </button>
          </CCol>
        </CRow>
      </template>

      <template v-if="CheckWidth >= 501">
        <CModal
          title="Calm Down!"
          centered
          color="warning"
          :show.sync="warningModal"
          :closeOnBackdrop="false"
          ref="mySwiper"
        >
          <h5>
            Students will be able to learn the next chapter when the system
            shows more than 80% of their previous chapter.
          </h5>
          <br />
        </CModal>
        <CModal
          title="Calm Down!"
          centered
          color="warning"
          :show.sync="adminLockTestModal"
          :closeOnBackdrop="false"
          ref="mySwiper"
        >
          <h5>The Post-Test has been locked by your instructor.</h5>
          <br />
        </CModal>

        <swiper class="swiper" :options="swiperOption">
          <template v-for="(item, index) in content.content.item">
            <swiper-slide :key="index">
              <div class="swip" :id="item._id">
                <img
                  :src="baseUrl + item.icon.enable.data"
                  :class="checkID(index)"
                  @click="funcRoute(item.navigate.action, index, item)"
                />
                <div class="name" style="text-align: center">
                  <h1
                    :class="checkLangClass()"
                    v-html="checkLanguage(item.title)"
                  ></h1>
                </div>
                <div class="ContentProgressBar">
                  <CProgress
                    showPercentage
                    class="ProgressBar"
                    :value="Math.floor(allChapter[index].progress)"
                    show-value
                    height="30px"
                    color="success"
                  />
                </div>
              </div>
            </swiper-slide>
          </template>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </template>

      <template v-else-if="CheckWidth <= 500">
        <swiper class="swiper" :options="swiperOptionPhone">
          <template v-for="(item, index) in content.content.item">
            <swiper-slide :key="index">
              <div class="swip" :id="item.id">
                <img
                  :src="baseUrl + item.icon.enable.data"
                  :class="checkID(index)"
                  @click="funcRoute(item.navigate.action, index, item)"
                />
                <center></center>
                <div class="name">
                  <h1
                    :class="checkLangClass()"
                    v-html="checkLanguage(item.title)"
                  ></h1>
                </div>

                <div class="ContentProgressBar">
                  <CProgress
                    showPercentage
                    class="ProgressBar"
                    :value="Math.floor(allChapter[index].progress)"
                    animated
                    show-value
                    height="30px"
                    color="success"
                  />
                </div>
              </div>
            </swiper-slide>
          </template>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </template>
    </template>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import {mapGetters} from 'vuex';
import '../../assets/scss/_chineseStyle.scss';
import '../../assets/css/sun.css';
import LoadingMDL from '../../components/loading/LoadingMDL';

export default {
  name: 'LessonSelect',
  title: '3D Coverflow effect Loop mode with multiple slides per group',
  components: {
    Swiper,
    SwiperSlide,
    LoadingMDL,
  },
  props: {
    id: String,
  },
  data() {
    return {
      hover: false,
      preTest: false,
      lang: '',
      content: {},
      baseUrl: '',
      counter: 86,
      swiperOption: {
        effect: 'coverflow',
        slidesPerView: 2.5,
        initialSlide: 0,
        grabCursor: false,
        centeredSlides: true,
        loop: true,
        loopFillGroupWithBlank: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 5,
          depth: 25,
          modifier: 5,
          slideShadows: false,
        },
      },
      swiperOptionPreTest: {
        effect: 'coverflow',
        slidesPerView: 2.5,
        grabCursor: false,
        centeredSlides: true,
        loop: false,
        loopFillGroupWithBlank: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 5,
          depth: 25,
          modifier: 5,
          slideShadows: false,
        },
      },
      swiperOptionPhone: {
        effect: 'coverflow',
        slidesPerView: 1,
        initialSlide: 0,
        grabCursor: false,
        centeredSlides: true,
        loop: true,
        loopFillGroupWithBlank: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 5,
          depth: 25,
          modifier: 5,
          slideShadows: false,
        },
      },
      CheckWidth: window.innerWidth,
      progress: {},
      progress2: {},
      warningModal: false,
      openPostTest: false,
      postTest: false,
      courseSection: '',
      startTime: '',
      courseCode: '',
      allChapter: [],
      postTestComplete: false,
      loading: true,
      openPostTestByAdmin: false,
      adminLockTestModal: false,
    };
  },
  computed: {
    ...mapGetters({
      allCourse: 'template/getTemplateContent',
      storeLanguage: 'language/getLanguage',
      getCourseChapterAndProgress: 'courses/getCourseChapterAndProgress',
      getLessonActive: 'necessary/getLessonActive',
      getChangeTest: 'template/getChangeTest',
      getCompletePostTestStatus: 'courses/getCompletePostTestStatus',
    }),
  },

  watch: {
    allCourse: function (val) {
      //val = {code:'id',templateCode='HP01-1'}
      this.content = val;
      let payload = {
        code: this.courseCode,
        section: this.$store.getters['necessary/getUserCourseSection'],
        courseId: this.courseCode,
      };
      this.$store.dispatch('courses/fetchProgressMenu', payload);
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
    getCourseChapterAndProgress: function (val) {
      this.progress2 = val;

      this.allChapter = this.progress2.template.filter((item) => {
        if (item.type == 'chapter') {
          return item;
        }
      });

      // console.log(this.allChapter);

      if (this.progress2 !== {}) {
        this.loading = false;
      }
      let LKT01Body = {
        code: this.courseCode,
        templateCode: 'LKT01-78',
      };
      this.$store.dispatch(
        'template/fetchContentForCheckingPosttest',
        LKT01Body
      );
    },
    getLessonActive: function (val) {
      this.swiperOption.initialSlide = val;
      this.swiperOptionPhone.initialSlide = val;
    },
    getChangeTest: function (val) {
      let openTestStatus = this.$store.getters['template/getTestStatus'];
      this.openPostTestByAdmin = openTestStatus;
      if (openTestStatus) {
        console.log('post test is open');
        let checkChapterProgressForUnlockPosttest = false;

        for (let i = 0; i < this.allChapter.length; i++) {
          if (this.allChapter[i].progress >= 80) {
            console.log('post test progress pass');
            checkChapterProgressForUnlockPosttest = true;
          } else {
            console.log('post test progress not pass');
            checkChapterProgressForUnlockPosttest = false;
            break;
          }
        } //loop
        if (checkChapterProgressForUnlockPosttest) {
          if (this.postTestComplete == true) {
            this.openPostTest = false;
          } else {
            this.openPostTest = true;
          }
        } else {
          console.log('cannot unlock post test');
          this.openPostTest = false;
        }
      } else {
        console.log('post test is not open');
        this.openPostTest = false;
      }
    },
    getCompletePostTestStatus: function (val) {
      this.postTestComplete = val.isComplete;
    },
  },
  created() {
    let lessonActive = this.$store.getters['necessary/getLessonActive'];
    this.swiperOption.initialSlide = lessonActive;
    this.swiperOptionPhone.initialSlide = lessonActive;
    this.lang = this.$store.state.language.language;
    this.baseUrl = process.env.VUE_APP_URL_SOUND;
    this.startTime = this.$helpers.getDateFormat();
    this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `HP01-` + this.$route.params.id;
    this.$store.dispatch('template/fetchContent', body);
    this.$store.dispatch('courses/fetchCompletePostTestStatus', body);
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkID(id) {
      var lock = this.allChapter[id].lock;
      var progress = this.allChapter[id].progress;
      if (!lock) {
        return 'img-island';
      } else if (lock) {
        if (progress >= 80) {
          return 'img-island';
        } else {
          return 'img-islandGrey';
        }
      }
      return 'img-island';
    },
    postTestClass() {
      if (!this.openPostTest) {
        return 'box-gray';
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            var spiltVal = val[i].value;
            let spl = spiltVal.split('-');
            return spl[0] + '<br/>' + spl[1];
          }
        }
      } else {
        console.log('change language is error!!');
      }
    },
    funcRoute(tempId, index, item) {
      this.$store.commit('necessary/setLessonActive', index);
      var lock = this.allChapter[index].lock;
      var progress = this.allChapter[index].progress;
      if (lock) {
        this.warningModal = true;
      } else {
        let str = tempId.split('-');
        let body = '/' + str[0] + '/' + str[1];
        this.$router.push(body);
      }
    },
    funcPostTest() {
      if (this.openPostTestByAdmin) {
        let body = '/LKT01/78';
        this.$router.push(body);
      } else {
        this.adminLockTestModal = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');

.vertical-center {
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box-gray {
  filter: grayscale(100%) blur(2px) !important;
}
.container-chinese-card {
  padding-top: 7% !important;
  padding-bottom: 5% !important;
}
.container-chinese-card-mobile {
  padding-top: 35% !important;
  padding-bottom: 5% !important;
}
.Greyfillter {
  filter: grayscale(100%);
}
.ContentProgressBar {
  display: flex;
  justify-content: center;

  .ProgressBar {
    background-color: #cccccc !important;
    margin-top: 5%;
    width: 70% !important;
    height: 20px !important;
    border-radius: 20px !important;
  }
}

.progress-bar-striped {
  background-image: none !important;
}

.example-3d {
  align-items: center;
  width: 100% !important ;
  padding-top: 11%;
  padding-bottom: 4%;
}

.swiper {
  min-height: 600px;
  height: 100%;
  width: auto;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    background-color: transparent;
    background-position: center;
    color: white;
  }
  .swip {
    height: inherit;
    filter: blur(5px);
  }
  .img-island {
    width: 80% !important;
    margin-bottom: 5%;
    cursor: pointer;
  }
  .img-islandGrey {
    width: 80% !important;
    margin-bottom: 5%;
    filter: grayscale(100%);
  }
  .swiper-slide-active {
    .swip {
      height: inherit;
      filter: blur(0px) !important;
    }
    .img-island {
      width: 80% !important;
      filter: grayscale(0%);
    }
  }

  .btn {
    width: 150px;
    height: 50px;
    border-radius: 60px;
    font-size: 30px;
  }

  .name h1 {
    font-size: 20px;
    color: black !important;
    margin-top: 1rem;
    font-size: 40px;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
  }
}
</style>
